"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubdomain = isSubdomain;
function isSubdomain(subdomain) {
    const nonSubdomains = /http(s:|:)\/\/((app\.|www\.|app\.feature\d+\.)(seesonar|develop-seesonar|staging-seesonar)\.com|localhost:[0-9]+)/u;
    if (nonSubdomains.test(subdomain)) {
        return false;
    }
    return true;
}
//# sourceMappingURL=lib.js.map